
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季">
              <a-select v-model="queryParam.saiji" placeholder="请选择"
                        allowClear >
                <a-select-option v-for="(option,index) in saijiOptions" :value="option.id">{{option.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>


          <a-col :md="6" :sm="24">
            <a-form-item label="考试时间">
              <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>

           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >

      <a-button @click="onSetting" style="margin-left: 8px">
        设置 <a-icon type="setting" />
      </a-button>

      <a-button type="primary" icon="plus" @click="addHandle" >新建</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.name}}
            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            举办时间 {{record.startdate}}
          </div>
      </span>
      <span slot="status" slot-scope="text,record">

        开始报名 {{record.stime|timeFormat}}
        <br/>
        结束报名 {{record.etime|timeFormat}}
        <br/>



        <a-tag v-if="record.status==1" color="green">进行中</a-tag>
        <a-tag v-else>未进行</a-tag>
        <a-tag v-if="record.type==1" color="green">显示</a-tag>
        <a-tag v-else>不显示</a-tag>


      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleServiceType(record)">套餐设置</a>
            <a-divider type="vertical" />
          <a @click="handleBaoming(record)">报名管理</a>
            <a-divider type="vertical" />
          <a @click="handleDocument(record)">相关文件</a> 
            <a @click="handleUserList(record)">场次合伙人</a> 
            <a-divider type="vertical" />
            <a @click="handleKaoguanList(record)">考官</a> 

        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="名称"
                      hasFeedback
                >
                <a-input   v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入名称' }]}
            ]"
                          placeholder="请输入名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="赛季"
                  hasFeedback
            >
            <a-select :disabled="formData.id>0" v-model="formData.saiji" placeholder="请选择"
                      allowClear >
              <a-select-option v-for="(option,index) in saijiOptions" :value="option.id">{{option.name}}</a-select-option>
            </a-select>
          </a-form-item>
              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="分组"
                      hasFeedback
              >
              <a-select mode="multiple"  v-model="formData.group_ids" placeholder="请选择"
                          allowClear >
                <a-select-option v-for="(option,index) in groupOptions" :value="option.id">{{option.name}}</a-select-option>
              </a-select>
                </a-form-item>
            </a-col>
           <a-col :md="12" :sm="24">
         <a-form-item
                 :labelCol="labelCol"
                 :wrapperCol="wrapperCol"
                 label="报名须知"
                 hasFeedback
           >

                <a-textarea   v-decorator="[
              'notice',
              {rules: []}
            ]"
                          placeholder="请输入报名须知"/>
         </a-form-item>
             </a-col>
            </a-row>
            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="所在地区"
                        hasFeedback
                >
                  <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.areas" changeOnSelect />
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="是否进行"
                        hasFeedback
                >
                  <r-switch  :formData="formData" field="status" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
                </a-form-item>
              </a-col>
            </a-row>


            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="是否显示"
                        hasFeedback
                >
                  <r-switch  :formData="formData" field="type" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
                </a-form-item>
              </a-col>

              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="发票名目"
                        hasFeedback
                > 
                
                <a-select  v-model="formData.fapiaomingxi" placeholder="请选择"
                          allowClear >
                  <a-select-option key="1" value="会务费">会务费</a-select-option>
                  <a-select-option key="2" value="培训费">培训费</a-select-option>
                  <a-select-option key="3" value="培训服务费">培训服务费</a-select-option>
                  <a-select-option key="4" value="服务费">服务费</a-select-option>
                  <a-select-option key="5" value="代定食宿费">代定食宿费</a-select-option>
                </a-select> 
                </a-form-item>
              </a-col>

            </a-row>


            <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="会议日期"
                      hasFeedback
              >
                <a-range-picker
                        v-model="formData.date_range_moment"
                        format="YYYY-MM-DD"
                />
              </a-form-item>

              </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="报名时间"
                      hasFeedback
              >
                <a-range-picker
                        v-model="formData.time_range_moment"
                        :showTime="{
        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
      }"
                        format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>

              </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24"  v-show="formData.gametype == 3">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="人员报名费"
                  hasFeedback
              >
                <a-input v-decorator="[
              'memberoneprice',
              {rules: []}
            ]"
                         placeholder="请输入人员报名费"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线上支付"
                  hasFeedback
              >
                <r-switch  :formData="formData" field="can_pay" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col> 
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="等级申报须知"
                      extra="会显示在等级申报页面"
                      hasFeedback
                >

                      <a-textarea   v-decorator="[
                    'grade_notice',
                    {rules: []}
                  ]"
                                placeholder="请输入等级申报须知"/>
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="资料订购成本"
                  hasFeedback
              >
                <a-input v-decorator="[
              'books_cost_price',
              {rules: []}
            ]"
                         placeholder="请输入资料订购成本"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="省市端可见"
                  hasFeedback
              >
                <r-switch  :formData="formData" field="province_show" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48"  >
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="报名人数限制"
                  hasFeedback
              >
                <a-input v-decorator="[
              'stationlimitmember',
              {rules: []}
            ]"
                         placeholder="请输入限制的报名人数"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="报名群二维码"
                  hasFeedback
              >
                <pic-uploader
                    :numberLimit="20"
                    :file-list="formData.wechat_erweiimg"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48" >
            <a-col :md="12" :sm="24" v-show="formData.gametype == 3">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否需要单位备案"
                  hasFeedback
              >
                <r-switch  :formData="formData" field="is_danwei_cert" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否显示导师团"
                  hasFeedback
              >
                <r-switch  :formData="formData" field="is_daoshi" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48" >
            <a-col :md="12" :sm="24"  >
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="仅发布者可见"
                  extra="在省市管理端，仅对发布者可见"
                  hasFeedback
              >
                <r-switch  :formData="formData" field="add_user_show" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24"> 

              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="仅发布者可见"
                  extra="在省市管理端，仅对发布者可见"
                  hasFeedback
              > 
                <user-picker
                  style="width: 200px; margin-right: 10px;"
                  :formData="formData"
                  @change="userChange"
                  field="user_id"
                /><br/>
                {{formData.user_name}}
                </a-form-item>

            </a-col>
          </a-row>
          
          <a-row :gutter="48" >
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否开启线下缴费"
                  hasFeedback
              >
                <r-switch  :formData="formData" field="is_offline_pay" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24" v-if="formData.is_offline_pay==1">
              <a-form-item
                      :labelCol="labelCol" 
                      :wrapperCol="wrapperCol"
                      label="收款二维码"
                      hasFeedback
              >
                <pic-uploader
                        :numberLimit="3"
                        :file-list="formData.pay_qrcode"
                />
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="类型"
                      hasFeedback
              >
                <a-select  v-model="formData.gametype" placeholder="请选择"
                          allowClear >
                  <a-select-option v-for="(option,index) in typeOptions" :key="index" :value="option.id">{{option.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="报名咨询二维码"
                      hasFeedback
              >
                <pic-uploader
                        :numberLimit="1"
                        :file-list="formData.erweiimg"
                />
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="小图"
                      hasFeedback
                      extra="推荐尺寸400x400"
              >
                <pic-uploader
                        :numberLimit="1"
                        :file-list="formData.pic"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="大图"
                      hasFeedback
                      extra="推荐尺寸1000x430"
              >
                <pic-uploader
                        :numberLimit="1"
                        :file-list="formData.pics"
                />
              </a-form-item>
            </a-col>
          </a-row>




          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报类型"
                      hasFeedback
              >

                <a-checkbox-group :options="shenbaoOptions" v-model="formData.shenbaotype" @change="" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="高级申报"
                      hasFeedback
              >

                <a-checkbox-group :options="gjsbOptions" v-model="formData.gjsbshow" @change="" />

              </a-form-item>
            </a-col>
            </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="是否允许申报一级"
                      hasFeedback
              >
                <r-switch  :formData="formData" field="is_apply_one" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="仅限本省报名"
                      hasFeedback
              >
                <r-switch  :formData="formData" field="onlyprovince" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="仅限市报名"
                        hasFeedback
                >
                    <r-switch  :formData="formData" field="onlycity" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
                </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">

            <a-col :md="48" :sm="48">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 22 }}"
                      label="报名附加信息"
                      extra="人员报名时需要添加的附加信息"
              >
                <div v-for="(field,fkey) in formData.extra_field" :key="fkey">
                  <a-input style="width: 200px;margin-right: 10px" v-model="field.label"
                            placeholder="请输入字段名称"/>

                  <a-input  style="width: 200px;margin-right: 10px" v-model="field.desc"
                            placeholder="请输入字段描述"/>
                            
                  <a-checkbox :checked="field.required" @change="(e)=>{ field.required =e.target.checked }">
                    必填
                  </a-checkbox>
                  <a-radio-group v-model:value="field.type" name="radioGroup">
                    <a-radio value="text">文本</a-radio>
                    <a-radio value="select">单选</a-radio>
                    <a-radio value="checkbox">多选</a-radio>
                    <a-radio value="pic">图片</a-radio> 
                  </a-radio-group> 
                  <a-textarea v-show="field.type=='select'||field.type=='checkbox'" style="width: 200px;margin-right: 10px" v-model="field.rules"
                            placeholder="请输入选项，一行一条"/>
 

                <pic-uploader
                    :numberLimit="4"
                    :file-list="field.pics"
                /> 


                  <a-icon
                          class="dynamic-delete-button"
                          type="minus-circle-o"
                          @click="() => removeExtraField(fkey)"
                  />
                </div>
                <div><a-button
                        type="dashed"
                        style="width: 100%"
                        @click="addExtraField"
                >
                  <a-icon type="plus" /> 增加附加项
                </a-button></div>

              </a-form-item>



            </a-col>


          </a-row>




          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上培训"
                      hasFeedback
              >
                <r-switch  :formData="formData" field="is_online" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      v-show="formData.is_online==1"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="开始序号"
                      extra="在线课程小程序码开始序号"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'video_start_index',
              {rules: [ ]}
            ]"
                          placeholder="请输入在线课程小程序码开始序号"/>
              </a-form-item>
            </a-col>

          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上开票"
                      hasFeedback
              >
                <r-switch  :formData="formData" field="can_kaipiao" :checkedValue="1" :unCheckedValue="2"  checkedChildren="开启" unCheckedChildren="关闭" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="上传视频"
                  hasFeedback
              >
                <r-switch :formData="formData" field="need_video" :checkedValue="1" :unCheckedValue="2"
                          checkedChildren="需要" unCheckedChildren="不需要"/>
              </a-form-item>
            </a-col>

          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上考试"
                      hasFeedback
              >
                <r-switch  :formData="formData" field="can_exame" :checkedValue="1" :unCheckedValue="2"  checkedChildren="开启" unCheckedChildren="关闭" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="显示结业证书"
                  hasFeedback
              >
                <r-switch  :formData="formData" field="show_cert" :checkedValue="1" :unCheckedValue="2"  checkedChildren="显示" unCheckedChildren="隐藏" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="结业证书显示日期"
                  hasFeedback
              >
                <a-date-picker
                    style="width: 100%"
                    v-model="formData.cert_time"
                    format="YYYY-MM-DD"
                />
              </a-form-item>

            </a-col>

            <a-col :md="12" :sm="24">
                <a-form-item
                        v-show="formData.can_exame==1"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="考试信息"
                        extra="请选择考试"
                        hasFeedback
                >
                  <a-select
                          optionFilterProp="title"  mode="multiple"  v-model="formData.exame_ids" placeholder="请选择"
                            allowClear >
                    <a-select-option v-for="(option,index) in exameOptions" :title="option.title" :value="option.id">{{option.title}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>



          </a-row>

           <a-row :gutter="48">

            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="考试信息（多项）"
                      extra="国培场景使用"
              >
                <div v-for="(field,fkey) in formData.exame_list" :key="fkey"> 

                  <a-select  style="width: 200px;margin-right: 10px"
                          optionFilterProp="title"   v-model="field.exame_id" placeholder="请选择"
                            allowClear >
                    <a-select-option :key="index" v-for="(option,index) in exameOptions" :title="option.title" :value="option.id">{{option.title}}</a-select-option>
                  </a-select>

                  <a-input  style="width: 200px;margin-right: 10px" v-model="field.name"
                            placeholder="考卷名称"/>

                  <a-checkbox :checked="field.need_video" @change="(e)=>{ field.need_video =e.target.checked }">
                    需要上传视频
                  </a-checkbox>

                  <a-icon
                          class="dynamic-delete-button"
                          type="minus-circle-o"
                          @click="() => removeExameList(fkey)"
                  />
                </div>
                <div><a-button
                        type="dashed"
                        style="width: 100%"
                        @click="addExameList"
                >
                  <a-icon type="plus" /> 增加考卷
                </a-button></div>

              </a-form-item>



            </a-col>


            <!-- <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="服装尺码表图片"
                  hasFeedback
              >
                <pic-uploader
                    :numberLimit="4"
                    :file-list="formData.clothes_pics"
                />
              </a-form-item>
            </a-col> -->


          </a-row>

          
          <a-row :gutter="48">

          <a-col :md="12" :sm="24">
            <a-form-item 
                    :labelCol="{
                      xs: { span: 24 },
                      sm: { span: 4 },}"
                    :wrapperCol="{
                      xs: { span: 24 },
                      sm: { span: 18 }}"
                    label="相关课程"
                    extra="请选择课程"
                    hasFeedback
            >
              <a-select 
                      optionFilterProp="title"  v-model="formData.course_id" placeholder="请选择"
                        allowClear >
                <a-select-option v-for="(option,index) in courseOptions" :title="option.title" :value="option.id">{{option.title}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <a-col :md="12" :sm="24">
           <a-form-item
                  label="相关课程分类"
                  extra="用户报名成功后点击在线学习跳转到课程分类列表"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <a-tree-select
                    v-decorator="[
                  'course_cate_id',
                  {rules: []}
                ]"
                    style=" width: 90% ; margin-right: 10px; "
                    :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                    :treeData="courseCateOptions" 
                    allowClear
                    treeNodeFilterProp="title"
                    placeholder='请选择分类'
                    treeDefaultExpandAll
                    v-model="formData.course_cate_id"
            >
            </a-tree-select>
            <a-popover content="请选择分类,支持多选">
              <a-icon type="question-circle" />
            </a-popover>
          </a-form-item>
          </a-col>


        </a-row>

          <a-row :gutter="48">

          <a-col :md="12" :sm="24">

            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="资料下载"
                    hasFeedback
            >
              <file-uploader
                      :file-list="formData.zips"
              />
            </a-form-item>
          </a-col></a-row>

          

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>




    <a-modal
        :maskClosable="false"
            title="服务套餐设置"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="serviceTypeVisible"
            @ok="serviceTypeVisible=false"
    >
      <a-spin :spinning="saveLoading">
          <a-table
                  :columns="serviceTypeColumns"
                  :dataSource="serviceTypeList"
                  :pagination="false"
                  rowKey="id"
                  :scroll="{ y: 300 }"
                  bordered
          >

        <span slot="show" slot-scope="text,record">
          <a-tag v-if="record.show==1" color="green">显示</a-tag>
          <a-tag v-else>隐藏</a-tag>
        </span>
        <span slot="loc" slot-scope="text,record">
          <a-tag v-if="record.loc==1" color="green">是</a-tag>
          <a-tag v-else>否</a-tag>
        </span>
            <span slot="onlyprovince" slot-scope="text,record">
          <a-tag v-if="record.onlyprovince==1" color="green">是</a-tag>
          <a-tag v-else>否</a-tag>
        </span>

            <template slot="action" slot-scope="text,record,index">
              <a href="javascript:;" @click="onEditServiceType(record)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm
                      title="确定删除此套餐吗"
                      @confirm="deleteServiceType(record,index)"
                      okText="确定"
                      cancelText="取消"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
              <a-button icon="plus" @click="onAddServiceType">新增</a-button>
            </template>
          </a-table>
      </a-spin>
    </a-modal>

    <a-modal
        :maskClosable="false"
            title="套餐操作"
            :width="1000"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="serviceTypeFormVisible"
            @ok="handleServiceTypeOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form2" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="名称"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入套餐名称' }]}
            ]"
                         placeholder="请输入名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="说明"
                      hasFeedback
              >
                <a-textarea    v-decorator="[
              'note',
              {rules: [ ]}
            ]"
                         placeholder="请输入说明"/>
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="单价"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'price',
              {rules: [{ required: true, message: '请输入单价' }]}
            ]"
                          placeholder="请输入单价"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="仅限本省购买"
                      hasFeedback
              >
                <r-switch  :formData="serviceTypeFormData" field="onlyprovince" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>

          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="仅限本地购买"
                      hasFeedback
              >
                <r-switch  :formData="serviceTypeFormData" field="loc" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="是否显示"
                      hasFeedback
              >
                <r-switch  :formData="serviceTypeFormData" field="show" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>


          </a-row>


            <a-row :gutter="48">

                <a-col :md="48" :sm="24">
                    <a-form-item
                            :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                            :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="仅限报过以下场次"
                      hasFeedback
              >
                  <a-select style="width: 500px" v-model="serviceTypeFormData.onlybaos"
                            mode="multiple" placeholder="请选择"
                            allowClear >
                      <a-select-option v-for="(option,index) in saiquOptions" :value="option.id">{{option.name}}</a-select-option>
                  </a-select>
                    </a-form-item>
            </a-col>


          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleServiceTypeCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleServiceTypeOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
            title="设置"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="settingVisible"
            @ok="handleSettingOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form3" >

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="裁判二级 > 一级"
                      extra="申报时间限制，单位为天数"
                      hasFeedback
              >
                <a-input v-model="settingFormData.gjsb_cp2_to_cp1" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="裁判一级 > 国家级"
                      extra="申报时间限制，单位为天数"
                      hasFeedback
              >
                <a-input v-model="settingFormData.gjsb_cp1_to_guojia" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="裁判国家级 > 国际级"
                      extra="申报时间限制，单位为天数"
                      hasFeedback
              >
                <a-input v-model="settingFormData.gjsb_cpguojia_to_guoji" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>

          <!--教练-->

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="教练二级 > 一级"
                      extra="申报时间限制，单位为天数"
                      hasFeedback
              >
                <a-input v-model="settingFormData.gjsb_jl2_to_jl1" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="教练一级 > 高级"
                      extra="申报时间限制，单位为天数"
                      hasFeedback
              >
                <a-input v-model="settingFormData.gjsb_jlyi_to_gaoji" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="教练高级 > 国家级"
                      extra="申报时间限制，单位为天数"
                      hasFeedback
              >
                <a-input v-model="settingFormData.gjsb_jlgao_to_guojia" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>




        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="settingVisible=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleSettingOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
            title="相关文件操作"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="documentVisible"
            @ok="documentVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-table
                  :columns="documentColumns" :dataSource="documentList" :pagination="false" rowKey="id" :scroll="{ y: 300 }" bordered>
            <span slot="name" slot-scope="name,record">
              {{record.title}}
            </span>
              <span slot="typename" slot-scope="name,record">
              <em v-if="record.type==1">
                  文件
              </em>
              <em v-else>
                  导师
              </em>
            </span>
            <template slot="action" slot-scope="text,record,index">
<!--              <a-divider type="vertical" />-->
              <a-popconfirm title="确定删除该文章吗" @confirm="deleteFile(record,index)"  okText="确定" cancelText="取消">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
              <content-picker style="width: 200px; margin-right: 10px;" :formData="huiyiFormData" field="content_id" />
                <a-select  style="width: 200px; margin-right: 10px;"  v-model="huiyiFormData.type" placeholder="类型"  >
                <a-select-option value="1">文件</a-select-option>
                <a-select-option value="2">导师</a-select-option>
                </a-select>
                <a-button icon="plus" @click="addFile" >新增</a-button>
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>




    <a-modal
        :maskClosable="false"
            title="场次合伙人"
            :width="800"
            v-model="userListVisible"
            @ok="userListVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-table :columns="userColumns" :dataSource="adminUserList"   rowKey="id" :scroll="{ y: 300 }" bordered>
            <span slot="name" slot-scope="name,record">
              <img :src="record.face" style="width: 40px; vertical-align: middle;" /> {{record.name}} ({{record.phone}})
            </span> 
            <template slot="action" slot-scope="text,record,index">
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除此人员吗" @confirm="deleteUser(record,index)"  okText="确定" cancelText="取消">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
              <user-picker style="width: 200px; margin-right: 10px;" :formData="userFormData" field="user_id" />
              <a-button icon="plus" @click="addUser" >新增</a-button>
            </template>
          </a-table>
        </a-form>

      </a-spin>
    </a-modal>





    <a-modal
        :maskClosable="false"
            title="场次考官"
            :width="800"
            v-model="kaoguanListVisible"
            @ok="kaoguanListVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-table :columns="kaoguanColumns" :dataSource="kaoguanUserList"   rowKey="id" :scroll="{ y: 300 }" bordered>
            <span slot="name" slot-scope="name,record">
              {{record.name}}({{record.num}}) {{record.grade}}
            </span> 
            <template slot="action" slot-scope="text,record,index">
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除此人员吗" @confirm="deleteKaoguan(record,index)"  okText="确定" cancelText="取消">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
              <kaoguan-picker style="width: 200px; margin-right: 10px;" @onSelect="kaoguanSelect"/>
              <a-button icon="plus" @click="addKaoguan" >新增</a-button>
            </template>
          </a-table>
        </a-form>

      </a-spin>
    </a-modal>


  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import ContentPicker from '@/components/ContentPicker/'
  import RSwitch from '@/components/RSwitch/'
  import areaOptions from '@/utils/area'
  import UserPicker from '@/components/UserPicker/'
  import KaoguanPicker from '@/components/KaoguanPicker/'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getSaiquList ,getSaiquDetail,editSaiqu,addSaiqu,getSaijiList,getGroupList,stationOptions,getServiceTypeList,serviceTypeDelete,getServiceTypeDetail,editServiceType,addServiceType,addHuiyiFile, getHuiyiFileList,deleteHuiyiFile,getSetting,setSetting 
  ,
  deleteAdminUser,
  getAdminUserList,
  addAdminUser, 

  deleteKaoguanUser,
  getKaoguanUserList,
  addKaoguanUser, 
  } from '@/api/huiyi'
  import {getHuiyiList} from "../../api/huiyi";


  import { getExameOptions} from '@/api/wexame' 
  import {  getCourseList,getCateTreeList  } from '@/api/course';

  export default {
    name: 'HuiyiSaiquList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      UserPicker,
      ContentPicker,
      STable,
      RSwitch,
      EditableCell,
      KaoguanPicker,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        documentVisible: false,
        saveLoading:false,
        settingVisible:false,
        // shenbaoOptions : [
        //   {'label':'裁判等级（舞蹈）','value':'caipandengjiwudao'},{'label':'裁判等级（技巧）','value':'caipandengjijiqiao'},{'label':'教练等级（舞蹈）','value':'jiaoliandengjiwudao'},{'label':'教练等级（技巧）','value':'jiaoliandengjijiqiao'}
        // ],
        shenbaoOptions : [
          {'label':'裁判等级','value':'caipandengjiwudao'},{'label':'教练等级','value':'jiaoliandengjiwudao'}
        ],
        gjsbOptions : [
          {'label':'高级裁判员资质申请','value':'caipan'},{'label':'高级教练员资质申请','value':'jiaolian'}
        ],
        courseCateOptions:[],
        formData:{
          id:0,
          status:1,
          type:1,
          is_online:2,
          can_kaipiao:2,
          need_video:2,
          can_exame:2,
          show_cert:2,
          onlyprovince:2,
          is_apply_one:2,
          onlycity:2,
          danwei:'',
          gametype:'',
          saidate_moment:null,
          saidate:'',
          time_range_moment:[],
          time_range:[],
          date_range_moment:[],
          date_range:[],
          erweiimg:[],
          pay_qrcode:[],
          wechat_erweiimg:[], 
          clothes_pics:[], 
          areas:[],
          extra_field:[],
          exame_list:[],
          shenbaotype:[],
          gjsbshow:[],
          pic:[],
          pics:[],
          group_ids:[],
          exame_ids:[],
          zips:[],
          stationlimitmember: 1,
          can_pay: 2,
          province_show: 1,
          is_danwei_cert: 2,
          course_cate_id: 2,
          is_daoshi: 2,
          add_user_show: 2,
          user_id: 0,
          user_name: '',
          is_offline_pay: 2,
          memberoneprice: '',
          books_cost_price: '',
        },
        huiyiFormData:{
          //station_id=271&content_id=33
          station_id:undefined,
          content_id: undefined,
        },
        saijiOptions:[],
        groupOptions:[],
        exameOptions:[],
          saiquOptions:[],
        typeOptions:[{
          name:'会议',
          id:1,
        },{
          name:'培训',
          id:2,
        },{
          name:'训练营',
          id:3,
        },{
          name:'论文科报会',
          id:4,
        },{
          name:'校局长论坛',
          id:5,
        },{
          name:'七彩星级',
          id:6,
        },{
          name:'七彩星级国培',
          id:7,
        },{
          name:'导师培训',
          id:8,
        },{
          name:'送培',
          id:9,
        }
        ],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        form2: this.$form.createForm(this),
        form3: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 162,
            scopedSlots: { customRender: 'action' },
          }
        ],

        //人员管理表头
        documentColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '标题',
            dataIndex: 'title',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '类型',
            width:'100px',
            dataIndex: 'type',
            scopedSlots: { customRender: 'typename' },
              filters: [
                  {
                      text: '文件',
                      value: '1'
                  },
                  {
                      text: '导师',
                      value: '2'
                  },
              ],
              filterMultiple:false,
              onFilter: (value, record) => record.type == value,
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '150px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        documentList:[],
        documentKeywords: '',
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;


          this.queryParam = Object.assign(this.queryParam,parameter);
          return getSaiquList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],

        //表头
        serviceTypeColumns: [
          {
            title: '名称',
            dataIndex: 'name',
          },
          {
            title: '价格',
            width: '150px',
            dataIndex: 'price',
          },
          {
            title: '仅限本地',
            width: '150px',
            dataIndex: 'loc',
            scopedSlots: { customRender: 'loc' },
          },
          {
            title: '仅限本省',
            width: '150px',
            dataIndex: 'onlyprovince',
            scopedSlots: { customRender: 'onlyprovince' },
          },
          {
            title: '显示',
            dataIndex: 'show',
            width: '150px',
            scopedSlots: { customRender: 'show' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 150,
            scopedSlots: { customRender: 'action' },
          },
        ],
        serviceTypeQuery: {
          saiqu: 0,
        },
        serviceTypeVisible:false,
        serviceTypeFormVisible:false,
        courseOptions:[],
        serviceTypeList: [],
        serviceTypeFormData:{
          id:0,
          name:'',
          onlyprovince: 1,
          loc:1,
          show:1,
            onlybaos:[],
        },
        settingFormData:{
          gjsb_cp2_to_cp1:0,
          gjsb_cp1_to_guojia:0,
          gjsb_cpguojia_to_guoji:0,
          gjsb_jl2_to_jl1:0,
          gjsb_jlyi_to_gaoji:0,
          gjsb_jlgao_to_guojia:0,
        },



      //人员管理表头
      userColumns: [
        {
          title: "#",
          dataIndex: "id",
          width: "80px",
        },
        {
          title: "用户名",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        }, 
        {
          title: "操作",
          dataIndex: "action",
          width: "150px",
          scopedSlots: { customRender: "action" },
        },
      ],
      adminUserList: [],
      userListVisible:false,
      userFormData: {
        user_id: undefined,
        saiqu: undefined,
      },


      //人员管理表头
      kaoguanColumns: [
        {
          title: "#",
          dataIndex: "id",
          width: "80px",
        },
        {
          title: "用户名",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        }, 
        {
          title: "操作",
          dataIndex: "action",
          width: "150px",
          scopedSlots: { customRender: "action" },
        },
      ],
      kaoguanUserList: [],

      kaoguanListVisible:false,

      kaoguanFormData: {
        kaoguan_id: undefined,
        saiqu: undefined,
      },

      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSaijiOptions();
      that.getGroupOptions();
      that.getExameOptions();
      that.getCourseOptions();
      that.stationOptions();
      that.getCourseCates();
    },
    methods: {
      moment,
      addHandle(){
        this.formData = {
          id:0,
          status:1,
          is_online:2,
          can_kaipiao:2,
          need_video:2,
          can_exame:2,
          show_cert:2,
          type:1,
          danwei:'',
          gametype:'',
          saidate_moment:null,
          saidate:'',
          time_range_moment:[],
          time_range:[],
          date_range_moment:[],
          date_range:[],
          erweiimg:[],
          pay_qrcode:[],
          wechat_erweiimg:[],
          clothes_pics:[],
          areas:[],
          onlyprovince:2,
          is_apply_one:2,
          shenbaotype:[],
          gjsbshow:[],
          pic:[],
          pics:[],
          extra_field:[],
          exame_list:[],
          group_ids:[],
          exame_ids:[],
          zips:[],
          stationlimitmember: 1,
          can_pay: 2,
          province_show: 1,
          is_danwei_cert: 2,
          is_daoshi: 2,
          add_user_show: 2,
          user_id: 0,
          user_name: '',
          is_offline_pay: 2,
          memberoneprice: '',
          books_cost_price: '',
        },
        this.form.resetFields();
        this.visible = true
      },
      handleCancel(){
        this.visible = false
      },
      getCourseCates(){
        let that = this;
        getCateTreeList()
              .then(res => {
                that.courseCateOptions =  res.data;
              })
      },
      handleServiceTypeCancel(){
        this.serviceTypeFormVisible = false
      },
      getSaijiOptions(){
        let that = this;
        getSaijiList().then(res =>{
          that.saijiOptions = res.data.list
        })
      },
      getGroupOptions(){
        let that = this;
        getGroupList().then(res =>{
          that.groupOptions = res.data.list
        })
      },
      getExameOptions(){
        let that = this;
        getExameOptions().then(res =>{
          that.exameOptions = res.data
        })
      },
      getCourseOptions(){
        let that = this;
        getCourseList({
          pageSize:100
        }).then(res =>{
          that.courseOptions = res.data.list
        })
      },
        stationOptions(){
        let that = this;
            stationOptions().then(res =>{
          that.saiquOptions = res.data
        })
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getSaiquDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            res.data.cert_time = moment(res.data.cert_time*1000).format('YYYY-MM-DD HH:mm:ss')
            res.data.cert_time = moment(res.data.cert_time,'YYYY-MM-DD')
            res.data.time_range_moment = [moment(res.data.stime*1000),moment(res.data.etime*1000)];
            res.data.date_range_moment = [moment(res.data.startdate,'YYYY-MM-DD'),moment(res.data.enddate,'YYYY-MM-DD')];
            res.data.group_ids = res.data.group_ids.map((item) =>{
              return parseInt(item);
            })
            res.data.exame_ids = res.data.exame_ids.map((item) =>{
              return parseInt(item);
            })
            res.data.exame_list = res.data.exame_list.map((item) =>{
              item.exame_id = parseInt(item.exame_id );
              return  (item);
            })
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      addExtraField(){
        if(this.formData.extra_field.length &&  this.formData.extra_field[this.formData.extra_field.length-1].name ==''){
          return false;
        }
        this.formData.extra_field.push({'label' :'','desc':'','required':true,'pics':[],'type':'text','rules':''});
      },
      removeExtraField(k){
        this.formData.extra_field.splice(k,1);
      },

      addExameList(){
        if(this.formData.exame_list.length &&  this.formData.exame_list[this.formData.exame_list.length-1].name ==''){
          return false;
        }
        this.formData.exame_list.push({'exame_id' :'','name':'','need_video':true});
      },
      removeExameList(k){
        this.formData.exame_list.splice(k,1);
      }, 
      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        if(self.formData.time_range_moment.length!=2){
          self.$message.error('请选择时间范围');
          return ;
        }
        if(self.formData.areas.length!=3){
          self.$message.error('请选择完整地区');
          return ;
        }
        if(!self.formData.saiji){
          self.$message.error('请选择赛季');
          return ;
        }
        if(self.formData.date_range_moment.length!=2){
          self.$message.error('请选择会议日期');
          return ;
        }
        if(!self.formData.gametype){
          self.$message.error('请选择类型');
          return ;
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            if(self.formData.id>0){

                editSaiqu({
                  id:self.formData.id,
                  name:values.name,
                  exame_activity_id:values.exame_activity_id,
                  exame_list:values.exame_list,
                  exame_ids:self.formData.exame_ids,
                  zips:self.formData.zips,
                  saiji:self.formData.saiji,
                  gametype:self.formData.gametype,
                  onlyprovince:self.formData.onlyprovince,
                  is_apply_one:self.formData.is_apply_one,
                  onlycity:self.formData.onlycity,
                  status:self.formData.status,
                  type:self.formData.type,
                  can_kaipiao:self.formData.can_kaipiao,
                  need_video:self.formData.need_video,
                  can_exame:self.formData.can_exame,
                  show_cert:self.formData.show_cert,
                  cert_time: parseInt(moment(self.formData.cert_time).valueOf() /1000),
                  area:self.formData.areas[self.formData.areas.length-1],
                  time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')],
                  date_range:[self.formData.date_range_moment[0].format('YYYY-MM-DD'),self.formData.date_range_moment[1].format('YYYY-MM-DD')],
                  fapiaomingxi:self.formData.fapiaomingxi,
                  notice:values.notice,
                  grade_notice:values.grade_notice,
                  is_online:self.formData.is_online,
                  video_start_index:values.video_start_index,
                  erweiimg:self.formData.erweiimg,
                  pay_qrcode:self.formData.pay_qrcode,
                  extra_field:self.formData.extra_field,
                  exame_list:self.formData.exame_list,
                  pic:self.formData.pic,
                  pics:self.formData.pics,
                  gjsbshow:self.formData.gjsbshow,
                  shenbaotype:self.formData.shenbaotype,
                  group_ids:self.formData.group_ids,
                  course_id: self.formData.course_id,
                  course_cate_id: self.formData.course_cate_id,
                  wechat_erweiimg:self.formData.wechat_erweiimg,
                  clothes_pics:self.formData.clothes_pics,
                  stationlimitmember: values.stationlimitmember,
                  can_pay: self.formData.can_pay,
                  province_show: self.formData.province_show,
                  is_danwei_cert: self.formData.is_danwei_cert,
                  is_daoshi: self.formData.is_daoshi,
                  add_user_show: self.formData.add_user_show,
                  user_id: self.formData.user_id,
                  user_name: self.formData.user_name,
                  is_offline_pay: self.formData.is_offline_pay,
                  memberoneprice: values.memberoneprice,
                  books_cost_price: values.books_cost_price,
                }).then(res => {
                  self.$message.success('修改成功')
                self.$refs.table.refresh()
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                  self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
                addSaiqu({
                  name:values.name,
                  saiji:self.formData.saiji,
                  gametype:self.formData.gametype,
                  exame_ids:self.formData.exame_ids,
                  zips:self.formData.zips,
                  onlyprovince:self.formData.onlyprovince,
                  is_apply_one:self.formData.is_apply_one,
                    onlycity:self.formData.onlycity,
                  status:self.formData.status,
                  type:self.formData.type,
                  can_kaipiao:self.formData.can_kaipiao,
                  need_video:self.formData.need_video,
                  can_exame:self.formData.can_exame,
                  show_cert:self.formData.show_cert,
                  cert_time: parseInt(moment(self.formData.cert_time).valueOf() /1000),
                  area:self.formData.areas[self.formData.areas.length-1],
                  time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')],
                  date_range:[self.formData.date_range_moment[0].format('YYYY-MM-DD'),self.formData.date_range_moment[1].format('YYYY-MM-DD')],
                  fapiaomingxi:self.formData.fapiaomingxi,
                  is_online:self.formData.is_online,
                  video_start_index:values.video_start_index,
                  erweiimg:self.formData.erweiimg,
                  pay_qrcode:self.formData.pay_qrcode,
                  extra_field:self.formData.extra_field,
                  pic:self.formData.pic,
                  pics:self.formData.pics,
                  gjsbshow:self.formData.gjsbshow,
                  shenbaotype:self.formData.shenbaotype,
                  group_ids:self.formData.group_ids,
                  notice:values.notice,
                  grade_notice:values.grade_notice,
                  wechat_erweiimg:self.formData.wechat_erweiimg,
                  clothes_pics:self.formData.clothes_pics,
                  stationlimitmember: values.stationlimitmember,
                  can_pay: self.formData.can_pay,
                  province_show: self.formData.province_show,
                  is_danwei_cert: self.formData.is_danwei_cert,
                  is_daoshi: self.formData.is_daoshi,
                  add_user_show: self.formData.add_user_show,
                  user_id: self.formData.user_id,
                  user_name: self.formData.user_name,
                  course_id: self.formData.course_id,
                  course_cate_id: self.formData.course_cate_id,
                  is_offline_pay: self.formData.is_offline_pay,
                  memberoneprice: values.memberoneprice,
                  books_cost_price: values.books_cost_price,
                }).then(res => {
                  self.$message.success('新增成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                  self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }

          }
        })
      },
      onAddServiceType(){
        this.serviceTypeFormData = {
          id:0,
          name:'',
          onlyprovince: 1,
          loc:1,
            onlybaos:[],
          show:1,
        },
        this.form2.resetFields();
        this.serviceTypeFormVisible = true
      },
      onEditServiceType(record){
        let self = this
        this.serviceTypeFormVisible = true
        getServiceTypeDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form2.setFieldsValue({ ...res.data })
            self.serviceTypeFormData.id = record.id;
            self.serviceTypeFormData = { ...res.data };
            self.serviceTypeFormData.onlybaos = self.serviceTypeFormData.onlybaos.map(item =>{
                return parseInt(item)
            });
          },200)
        })
      },
      deleteServiceType(record){
        let self = this;
        serviceTypeDelete({ id: record.id }).then(res =>{
          self.fetchServiceTypeList();
        })
      },
      handleServiceType(record){
        let self = this
        self.fetchServiceTypeList()
        self.serviceTypeQuery.saiqu = record.id;
        self.serviceTypeVisible = true
      },
      handleBaoming(record) {
        // console.log("handleBaoming", record)
        this.$router.push({
          name: 'HuiyiApplyList',
          query: {
            saiji: record.saiji,
            saiqu: record.id,
          }
        })
      },

      handleDocument(record) {
        let self = this
        self.huiyiFormData.station_id = record.id;
        self.getDocumentList();

        this.documentVisible = true
      },

      getDocumentList(){
        let self = this
        getHuiyiFileList({station_id: self.huiyiFormData.station_id}).then(res => {
          self.documentList = res.data
        })
      },

      addFile(){
        let self = this;
        if(!self.huiyiFormData.content_id){
          self.$message.error('请选择文章');
          return ;
        }
        if(!self.huiyiFormData.type){
          self.$message.error('请选择类型');
          return ;
        }
        addHuiyiFile(self.huiyiFormData).then(res => {
          self.getDocumentList();

          self.huiyiFormData.content_id = undefined;
          // self.huiyiFormData.station_id = undefined;

          self.$message.success('新增成功')
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
      },
      deleteFile(record,index){
        let self = this;
        deleteHuiyiFile({
          station_id:self.huiyiFormData.station_id,
          content_id:record.id,
        }).then(res => {
          self.$message.success('删除成功')
          self.documentList.splice(index,1);
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
      },


      fetchServiceTypeList() {
        let self = this
        getServiceTypeList(self.serviceTypeQuery).then(res => {
          self.serviceTypeList = res.data
        })
      },


      // 增改 处理
      handleServiceTypeOk(e) {
        let self = this;
        e.preventDefault()
        this.form2.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.serviceTypeFormData)
            self.saveLoading = true;
            if(self.serviceTypeFormData.id>0){
              editServiceType({
                id:self.serviceTypeFormData.id,
                name:values.name,
                price:values.price,
                note:values.note,
                loc:self.serviceTypeFormData.loc,
                onlyprovince:self.serviceTypeFormData.onlyprovince,
                show:self.serviceTypeFormData.show,
                  onlybaos:self.serviceTypeFormData.onlybaos,
              }).then(res => {
                self.$message.success('修改成功')

                self.fetchServiceTypeList();

                self.serviceTypeFormVisible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
              addServiceType({
                name:values.name,
                price:values.price,
                note:values.note,
                saiqu:self.serviceTypeQuery.saiqu,
                loc:self.serviceTypeFormData.loc,
                onlyprovince:self.serviceTypeFormData.onlyprovince,
                show:self.serviceTypeFormData.show,
                  onlybaos:self.serviceTypeFormData.onlybaos,
              }).then(res => {
                self.$message.success('新增成功')
                self.fetchServiceTypeList();


                self.serviceTypeFormVisible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }

          }
        })
      },



      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },


      onSetting(){
        let self = this
        this.settingVisible = true
        getSetting( ).then(res => {
          self.settingFormData = res.data;
          // console.log(this.mdl)
        })
      },

      userChange(val){
        console.log(val)
        this.formData.user_name = val.name
      }, 
      // 增改 处理
      handleSettingOk(e) {
        let self = this;
        e.preventDefault()
        this.form2.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            self.saveLoading = true;
            setSetting(self.settingFormData).then(res => {
              self.$message.success('修改成功')
              self.settingVisible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },


      handleUserList(record, index) {
        this.userListVisible = true;
        this.userFormData.saiqu = record.id;  
        this.fetchUser();
      },
    fetchUser() {
      let that = this; 
      getAdminUserList({
        saiqu: that.userFormData.saiqu
      }).then(
        (res) => {
          that.adminUserList = res.data; 
        }
      );
    },
    addUser() {
      let self = this;
      if (!self.userFormData.user_id) {
        self.$message.error("请选择人员");
        return;
      } 
      console.log(self.userFormData);

      addAdminUser(self.userFormData)
        .then((res) => {
          self.userFormData.user_id = undefined; 
          self.$message.success("新增成功");
          self.fetchUser(); 
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    deleteUser(record, index) {
      let self = this;
      deleteAdminUser({
        user_id: record.user_id,
        saiqu: self.userFormData.saiqu,
      })
        .then((res) => {
          self.$message.success("删除成功");
          self.adminUserList.splice(index, 1); 
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
 
    handleKaoguanList(record, index) {
        this.kaoguanListVisible = true;
        this.kaoguanFormData.saiqu = record.id;  
        this.fetchKaoguan();
      },
      fetchKaoguan() {
      let that = this; 
      getKaoguanUserList({
        saiqu: that.kaoguanFormData.saiqu
      }).then(
        (res) => {
          that.kaoguanUserList = res.data; 
        }
      );
    },
    addKaoguan() {
      let self = this;
      if (!self.kaoguanFormData.kaoguan_id) {
        self.$message.error("请选择人员");
        return;
      } 
      console.log(self.kaoguanFormData);

      addKaoguanUser(self.kaoguanFormData)
        .then((res) => {
          self.kaoguanFormData.kaoguan_id = undefined; 
          self.$message.success("新增成功");
          self.fetchKaoguan(); 
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    kaoguanSelect(val){
      console.log('kaoguanSelect',val)
      this.kaoguanFormData.kaoguan_id = val.id
    },
    deleteKaoguan(record, index) {
      let self = this;
      deleteKaoguanUser({
        kaoguan_id: record.kaoguan_id,
        saiqu: self.kaoguanFormData.saiqu,
      })
        .then((res) => {
          self.$message.success("删除成功");
          self.kaoguanUserList.splice(index, 1); 
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },


    },
    filters:{
    },
    watch: {
    }
  }
</script>
